export const MONTHS_LIST = [
  { value: 'JANUARY', label: 'JANUARY', code: 1 },
  { value: 'FEBRUARY', label: 'FEBRUARY', code: 2 },
  { value: 'MARCH', label: 'MARCH', code: 3 },
  { value: 'APRIL', label: 'APRIL', code: 4 },
  { value: 'MAY', label: 'MAY', code: 5 },
  { value: 'JUNE', label: 'JUNE', code: 6 },
  { value: 'JULY', label: 'JULY', code: 7 },
  { value: 'AUGUST', label: 'AUGUST', code: 8 },
  { value: 'SEPTEMBER', label: 'SEPTEMBER', code: 9 },
  { value: 'OCTOBER', label: 'OCTOBER', code: 10 },
  { value: 'NOVEMBER', label: 'NOVEMBER', code: 11 },
  { value: 'DECEMBER', label: 'DECEMBER', code: 12 },
];
